import { CheckoutPageLayout } from "./CheckoutPageLayout";
import {
  SkeletonContainer,
  SkeletonAvatar,
  SkeletonText,
} from "../../../../components/skeleton/Skeleton";
import { SpinnerLegacy } from "../../../../components";
import { useIsDesktop } from "./useIsDesktop";

export const CheckoutPageLoading = ({
  title,
  description,
  onClickLeftIcon,
}: {
  title: string;
  description: string;
  onClickLeftIcon?: () => void;
}) => {
  const { isDesktop } = useIsDesktop();

  const aside = (
    <div className="flex flex-1 flex-col p-4">
      <SkeletonContainer className="flex flex-1 flex-col gap-4">
        <SkeletonAvatar className="h-24 w-24" />

        <div className="flex flex-col gap-2">
          <SkeletonText className="h-6 w-1/2" />
          <SkeletonText className="h-6 w-1/2" />
          <SkeletonText className="h-6 w-full" />
          <SkeletonText className="h-6 w-full" />
          <SkeletonText className="h-6 w-full" />
          <SkeletonText className="h-6 w-full" />
        </div>
        <SkeletonText className="h-32 w-full" />
        <div className="flex flex-col gap-2">
          <SkeletonText className="h-6 w-full" />
          <SkeletonText className="h-6 w-full" />
        </div>
      </SkeletonContainer>
    </div>
  );

  return (
    <CheckoutPageLayout
      title={title}
      alerts={null}
      aside={isDesktop ? aside : null}
      onClickLeftIcon={onClickLeftIcon}
    >
      <div className="flex h-full flex-1 flex-col items-center justify-center">
        <SpinnerLegacy />
        <span className="text-xl font-semibold">{description}</span>
      </div>
    </CheckoutPageLayout>
  );
};
